import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { parseRequestError } from '@/app/common/utilities.ts'

export type BulkAssignPurseBankAccountPayload = {
  program_id: number
  bank_account_id: number
  program_purse_ids: number[]
}

/**
 * Assigns one bank account to several purses at once. The API applies it all-or-nothing: if any
 * purse id does not belong to the program, no purse is updated.
 */
async function bulkAssignPurseBankAccount(
  payload: BulkAssignPurseBankAccountPayload
) {
  try {
    await axios.put('program_purses/bank_account', payload)
    return null
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const useBulkAssignPurseBankAccount = () => {
  return useMutation({
    mutationFn: bulkAssignPurseBankAccount,
  })
}
